// app/javascript/controllers/sortable_controller.js

import { Controller } from "@hotwired/stimulus"

import Sortable from "sortablejs"

export default class extends Controller {
    /**
     * Connect lifecycle callback is invoked when the controller is connected to the DOM.
     */

    static values = { project: String, estimate: String }
    connect() {
        this.initializeSortableForElement();
    }

    disconnect() {
        this.sortable?.destroy();
        this.sortable = null;
    }

    /**
     * Initializes Sortable.js on the associated element and sets up event bindings.
     */
    initializeSortableForElement() {
        const projectId = this.projectValue;
        const estimateId = this.estimateValue;

        // Step 1: Sanitize the element's ID to remove all special characters
        const rawId = this.element.id;
        const sanitizedId = this.sanitizeId(rawId);

        // Debugging: Log the raw and sanitized IDs
        console.log("Raw ID:", rawId);
        console.log("Sanitized ID:", sanitizedId);

        // Step 2: Assign the sanitized ID back to the element if it has changed
        if (rawId !== sanitizedId) {
            this.element.id = sanitizedId;
            console.log(`Element ID updated to: ${sanitizedId}`);
        }

        // Step 3: Initialize Sortable.js directly on the DOM element
        this.sortable = new Sortable(this.element, {
            animation: 150,
            handle: '.drag_handle',                 // only drag via your handle cell
            draggable: 'tr.draggable_item_rows',     // matches the class on your <tr>
            onEnd: (event) => this.handleUpdate(event, projectId, estimateId)
        });
    }

    /**
     * Sanitizes a raw ID by replacing all non-alphanumeric characters with underscores.
     * @param {string} rawId - The original ID containing potential special characters.
     * @returns {string} sanitizedId - The sanitized ID with special characters replaced by "_".
     */
    sanitizeId(rawId) {
        return rawId.replace(/[^a-zA-Z0-9]/g, "_");
    }

    /**
     * Handles the 'update' event triggered by Sortable.js or jQuery.
     * @param {Event} event - The event object.
     * @param {string} projectId - The project ID retrieved from data attributes.
     * @param {string} estimateId - The estimate ID retrieved from data attributes.
     */
    handleUpdate(event, projectId, estimateId) {
        event.preventDefault();
        console.log("Sortable update triggered...");

        let itemsOrder = [];
        const draggableItems = $(this.element).find(".draggable_item_rows");

        draggableItems.each((index, element) => {
            const $element = $(element);
            const itemIndex = index;
            const itemForm = $element.find("form.edit_estimate_item");
            const itemOrderKey = $element.find('input[name="estimate_item[item_order_key]"]');

            // Extract the itemId from the form's id attribute (e.g., "edit_estimate_item_123")
            const formId = itemForm.attr("id");
            const itemId = formId ? formId.split("_")[3] : null;

            if (!itemId) {
                console.error(`Unable to extract item ID from form ID: ${formId}`);
                return;
            }

            const oldVal = itemOrderKey.val();
            let hasChanged = false;

            if (oldVal !== String(itemIndex)) {
                hasChanged = true;
            }

            itemOrderKey.val(itemIndex);
            itemsOrder.push(itemIndex);

            // Send AJAX update if the order has changed
            if (hasChanged) {
                $.ajax({
                    url: `/projects/${projectId}/estimates/${estimateId}/estimate_items/${itemId}`,
                    method: "PATCH",
                    dataType: "json",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
                    },
                    data: JSON.stringify({
                        estimate_item: {
                            item_order_key: itemIndex,
                        },
                    }),
                })
                    .done(() => {
                        console.log(`Successfully updated item ID=${itemId} with order key=${itemIndex}`);
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        console.error(`Failed to update item ID=${itemId}: ${textStatus}, ${errorThrown}`);
                    });
            }
        });

        // Persist the order in localStorage
        localStorage.setItem("itemsOrder", JSON.stringify(itemsOrder));
    }
}
